'use strict';

module.exports = function isNegativeZero(number) {
	return number === 0 && (1 / number) === -Infinity;
};




//////////////////
// WEBPACK FOOTER
// ./~/is-negative-zero/index.js
// module id = 673
// module chunks = 0 1